import React, {useState} from 'react';
import cls from './Modal.module.scss';
import {useAppSelector} from "../../../hooks/redux";
import {useActions} from "../../../hooks/useActions";
import {useTranslation} from "react-i18next";
import {capitalize} from "../../../shared/utils";
import PaypalCheckoutButton from "../../PaypalCheckoutButton/PaypalCheckoutButton";
import {plans} from "../../../global/temp/plans";


const Modal = () => {
    const {show, plan, price} = useAppSelector(state => state.modalSlice)
    const {setClose} = useActions()
    const {t} = useTranslation('main')
    const [isOpen, setIsOpen] = useState(false)

    const desc = plans.find(item => item.plan === plan)?.description

    if (!plan) return <></>

    return (
        <div className={`${cls.modal} ${show ? cls.show : ''}`}>
            <div className={cls.content}>
                <span
                    onClick={() => {
                        setClose()
                        setIsOpen(false)
                    }}
                    className={cls.close}
                >
                    &times;
                </span>
                <div className={`${cls.left} ${cls[plan]}`}>
                    <img
                        src={require(`../../../assets/images/svg/plan_${plan}.svg`)}
                        alt={'Plan'}
                    />
                </div>
                <div className={cls.right}>
                    <div className={cls.top}>
                        <h1>{t(`${capitalize(plan)} Plan`)}</h1>
                        <h2>${price}</h2>
                    </div>
                    <div className={cls.description}>
                        <p>&mdash;&nbsp;{desc && t(plan).split('^')[0]}</p>
                        <p>&mdash;&nbsp;{desc && t(plan).split('^')[1]}</p>
                    </div>
                    <div className={`${cls.bottom} ${isOpen ? cls.open : ''}`}>
                        <PaypalCheckoutButton
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
